import { AtomEffect } from 'recoil';

export const getLocalStorageItem = (key: string) => {
  const savedValue = localStorage.getItem(key);
  let val = undefined;
  if (savedValue != null) {
    try {
      val = JSON.parse(savedValue);
    } catch (_) {}
  }
  return val;
};

export const localStorageEffect: <T>(
  key: string,
  setInitialValue?: boolean
) => AtomEffect<T> =
  (key: string, setInitialValue = true) =>
  ({ setSelf, onSet }) => {
    if (setInitialValue) {
      const savedValue = getLocalStorageItem(key);
      if (savedValue) {
        setSelf(savedValue);
      }
    }

    onSet((newValue, _, isReset) => {
      isReset
        ? localStorage.removeItem(key)
        : localStorage.setItem(key, JSON.stringify(newValue));
    });
  };
